module.exports = __webpack_public_path__ + "static/img/glove_argent.78be201.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_argent.png
// module id = sTyT
// module chunks = 0